import { EIremboFormlyFieldTypes } from '@irembo-andela/irembogov3-common';

export const NonDataElementFormlyFieldTypes: EIremboFormlyFieldTypes[] = [
  EIremboFormlyFieldTypes['formly-group'],
  EIremboFormlyFieldTypes.sections,
  EIremboFormlyFieldTypes.block,
];
